import React from "react";
import { NavLink } from "../../models/NavLink";
import { RouteItem } from "../../models/RouteItem";
import { useTranslation } from "react-i18next";
import { Box, Collapse, List } from "@mui/material";
import { useMatches } from "react-router-dom";
import SidebarItem from "./SidebarItem";
import { common, report } from "../../i18n";

interface NavComponentProps {
  routes: RouteItem[];
  link: NavLink;
  parentOpen: boolean;
  index: number;
  width: number;
  leftImgSize?: number;
  leftAvatarSize?: number;
}

const getRoute = (routes: RouteItem[], linkPath: string) => {
  const route = routes.find((item) => item.path === linkPath);
  return {
    name: route?.title || "",
    link: linkPath,
    image: route?.image,
  };
};

const NavComponent = (props: NavComponentProps) => {
  const {
    link,
    parentOpen,
    index,
    routes,
    width,
    leftImgSize,
    leftAvatarSize,
  } = props;
  const matches = useMatches();
  const { t } = useTranslation([common, report]);

  const [open, setOpen] = React.useState<boolean>(true);

  // เช็คว่าเป็นหน้าปัจจุบันหรือไม่
  const isCurrentPath = matches.some((item) => item.pathname === link.path);

  const route = getRoute(routes, link.path);
  const hasChildren = !!(link.children && link.children.length > 0);

  // ควบคุมไอคอนลูกศร
  const chevronIcon =
    open && parentOpen ? "/img/chevron-down.svg" : "/img/chevron-right.svg";

  // Magic Number 30px ถูกอธิบายเป็นตัวแปรชัดเจน
  const INDENT_STEP_PX = 30;
  const paddingLeft = `${INDENT_STEP_PX * index}px`;

  const handleToggle = () => setOpen((prevOpen) => !prevOpen);

  return (
    <Box component="li" sx={{ listStyle: "none" }}>
      <SidebarItem
        className={`sidebar-menu ${isCurrentPath ? "seleted" : ""}`}
        iconType="img"
        icon={route.image}
        iconSize={leftImgSize}
        avatarSize={leftAvatarSize}
        onToggle={handleToggle}
        paddingLeft={paddingLeft}
        showHoverBox={index > 0}
        labelVariant={index === 0 ? "h3" : "body1"}
        label={t(route.name)}
        link={hasChildren ? undefined : route.link} // 💡 ไม่ส่ง link ไปถ้ามันมีลูก
        endIcon={hasChildren ? chevronIcon : undefined}
        endIconClassName="chevron"
        endIconAlt="Toggle Menu"
        endIconSize="10px"
        onEndIconClick={handleToggle}
      />

      {hasChildren && (
        <Collapse
          className="children"
          in={open && parentOpen}
          timeout="auto"
          unmountOnExit
        >
          <List
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              p: 0,
              mt: "10px",
            }}
          >
            {link.children!.map((childItem) => (
              <NavComponent
                key={childItem.path}
                link={childItem}
                parentOpen={parentOpen}
                index={index + 1}
                routes={routes}
                width={width}
                leftImgSize={leftImgSize}
                leftAvatarSize={leftAvatarSize}
              />
            ))}
          </List>
        </Collapse>
      )}
    </Box>
  );
};

export default NavComponent;
